import TotalesBonificacion from "./TotalesBonificacion";

export default TotalesBonificacion;
